import React from "react";
import {Route} from "react-router-dom";
import {Show} from "../../views/picking/order/index";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import RetailerUnloader from "../../hoc/retailer/retailerUnloader";
import {sessionStore} from "../../utils/sessionStore";
import OrderList from "../../views/oms/OrderList";

let routes = [];
const applications = sessionStore.get("applications");

if (applications && applications["picking"]) {
    routes.push([
        <Route
            path="/picking/orders/:params"
            component={RequireAuthentication(RetailerUnloader(OrderList))}
            exact
            key="order"
        />,
        <Route
            path="/picking/orders/show/:id"
            component={RequireAuthentication(RetailerUnloader(Show))}
            exact
            key="show"
        />,
    ])
}

export default routes;
